module.exports = __webpack_public_path__ + "img/jxsl.8ed5b143.png";